import React from "react";

interface JSONLDProps {
    JSONLD: object;
}
export default function JSONLD({ JSONLD }: JSONLDProps): JSX.Element {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(JSONLD) }}
        />
    );
}
